import { replace } from 'react-router-redux';
import { change } from 'redux-form';

import { handleErrorException, loading, success } from 'State/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { UpdateBidDetailsEnum } from 'Common/FieldEnum';
import { UPDATE_BID_DETAILS_FORM_NAME } from 'Common/FormEnum';

import * as types from './types';

export const updateBidDetails = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.UPDATING_BID_DETAILS, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'InvBidPrice/WriteBidPrices',
        model
      );
      dispatch(resetDirty());
      dispatch(success(types.BID_DETAIL_SUBMIT));
      if (response.data.Errors && response.data.Errors.length) {
        response.data.Errors.forEach(error => {
          if (error.Title === TitleEnum.Report) {
            dispatch({
              type: types.SET_BID_DETAIL_PRINT_DATA,
              payload: error.Message,
            });
          }
        });
      }
      dispatch(replace('/updatebiddetails'));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while updating bid details. Please try again',
      };
      dispatch(
        handleErrorException(ex, types.BID_DETAIL_SUBMIT_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.UPDATING_BID_DETAILS, false));
    }
  };
};

export const clearError = () => {
  return {
    type: types.CLEAR_BID_DETAILS_ERROR,
  };
};

export const getBidDetails = input => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.BID_DETAILS_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'InvBidPrice/GetBidPrices',
        input
      );
      dispatch(success(types.BID_DETAILS_DATA, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching bid details. Please try again',
      };
      dispatch(
        handleErrorException(ex, types.BID_DETAILS_LOADING_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.BID_DETAILS_LOADING, false));
    }
  };
};

export const resetGrid = () => {
  return change(
    UPDATE_BID_DETAILS_FORM_NAME,
    UpdateBidDetailsEnum.BidDetailsInfo,
    []
  );
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/updateBidDetails/actions.js